import { getIntentLink } from '../intents/intentSelectors';
import { makeLinkWithQueryParams } from '../intents/linkUtils';
import { getHublet, getIsNewPortalCreated } from '../store/app/selectors';
import { getWordpressAuthResponse } from '../store/integrations/selectors';
import { wordpressRedirect } from './productLinks';
export const getWordPressRedirect = state => {
  const hublet = getHublet(state);
  const intentLink = getIntentLink(state);
  const isNewPortal = getIsNewPortalCreated(state);
  const wordpressAuthorizationResponse = getWordpressAuthResponse(state);

  if (intentLink) {
    return makeLinkWithQueryParams({
      link: intentLink,
      hublet
    });
  }

  return wordpressRedirect({
    isNewPortal,
    hublet,
    authorization: wordpressAuthorizationResponse
  });
};